import { AdminBarberRepository } from "../../Repository";

export async function changeFullName(
  fullName: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.setFullName(fullName);
}
